import React from 'react'
import {
    Button, Dialog, DialogActions,
    withStyles, withMobileDialog
} from 'material-ui'

const styles = theme => ({
    video: {
        margin: 20,
        maxHeight: "80vh",
    }
})

const VideoDialog = withMobileDialog()(
    ({
        classes, open, fullScreen, onClose,
    }) => (
        <Dialog open={open} fullScreen={fullScreen} onClose={onClose} maxWidth={"false"}>
            <iframe className={classes.video} src="https://player.vimeo.com/video/285904228" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
            <DialogActions>
                <Button onClick={onClose} color="primary">Close</Button>
            </DialogActions>
        </Dialog>
    )
)

export default withStyles(styles)(VideoDialog)


// WEBPACK FOOTER //
// ./src/components/VideoDialog.jsx